var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24996 13.1667H9.24996M4.24996 10.6667H9.24996M7.58361 1.50073C7.50399 1.5 7.41444 1.5 7.31222 1.5H3.58346C2.65003 1.5 2.18298 1.5 1.82646 1.68166C1.51285 1.84145 1.25807 2.09623 1.09828 2.40983C0.916626 2.76635 0.916626 3.23341 0.916626 4.16683V13.8335C0.916626 14.7669 0.916626 15.2334 1.09828 15.5899C1.25807 15.9035 1.51285 16.1587 1.82646 16.3185C2.18263 16.5 2.64913 16.5 3.58074 16.5L9.9192 16.5C10.8508 16.5 11.3166 16.5 11.6728 16.3185C11.9864 16.1587 12.242 15.9035 12.4018 15.5899C12.5833 15.2337 12.5833 14.7679 12.5833 13.8363V6.7714C12.5833 6.66918 12.5832 6.57961 12.5825 6.5M7.58361 1.50073C7.82149 1.5029 7.97139 1.51172 8.11511 1.54623C8.28517 1.58705 8.44817 1.65439 8.59729 1.74577C8.76543 1.84881 8.9098 1.99318 9.19788 2.28125L11.8024 4.88582C12.0907 5.17407 12.234 5.3178 12.3371 5.486C12.4285 5.63512 12.4961 5.79771 12.5369 5.96777C12.5714 6.11149 12.5803 6.26212 12.5825 6.5M7.58361 1.50073L7.58329 3.83351C7.58329 4.76693 7.58329 5.23346 7.76495 5.58998C7.92474 5.90358 8.17952 6.15873 8.49312 6.31852C8.84929 6.5 9.3158 6.5 10.2474 6.5H12.5825",
    stroke: "#00AA5B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/vector2.bc916f9592fd177f947f623199956423.svg";
export { ForwardRef as ReactComponent };